<template></template>

<script>
  import { vuexOidcProcessSilentSignInCallback } from 'vuex-oidc';
  import { oidcSettings } from '@/settings/oidcSettings';

  export default {
    mounted() {
      vuexOidcProcessSilentSignInCallback(oidcSettings);
    }
  };
</script>
